/**
 * Enlarged field-report photo so an operator can read faces, plates, and scene
 * without opening the baseball card.
 */
import React from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const FieldPhotoReview: React.FC<{
  open: boolean;
  src: string | null;
  title: string;
  alt?: string;
  swapLabel?: string;
  onSwap?: () => void;
  onClose: () => void;
}> = ({ open, src, title, alt, swapLabel, onSwap, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={false}
    PaperProps={{
      sx: {
        bgcolor: '#0b1017',
        backgroundImage: 'none',
        m: 1,
        maxWidth: 'min(1100px, 96vw)',
      },
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.25, pt: 0.85, pb: 0.5 }}>
      <Typography variant="caption" sx={{ flex: 1, fontWeight: 700, minWidth: 0 }} noWrap>
        {title}
      </Typography>
      {onSwap && (
        <Box
          component="button"
          type="button"
          onClick={onSwap}
          sx={{
            border: 0,
            bgcolor: 'transparent',
            color: '#8a939f',
            font: 'inherit',
            fontSize: '0.62rem',
            fontWeight: 700,
            cursor: 'pointer',
            '&:hover': { color: '#e8ebee' },
          }}
        >
          {swapLabel || 'Show other'}
        </Box>
      )}
      <IconButton size="small" aria-label="Close photo" onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
    {src ? (
      <Box
        component="img"
        src={src}
        alt={alt || title}
        sx={{
          display: 'block',
          width: '100%',
          maxHeight: '82vh',
          objectFit: 'contain',
          bgcolor: '#000',
        }}
      />
    ) : (
      <Typography variant="caption" color="text.secondary" sx={{ px: 1.5, pb: 1.5 }}>
        Photo is still loading.
      </Typography>
    )}
  </Dialog>
);

export default FieldPhotoReview;
